'use client'

import { toggleOneTrustInfoDisplay } from '@marketplace-web/shared/consent'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

type Props = {
  cookieSettingsText: string
}

const CookieSettingsButton = ({ cookieSettingsText }: Props) => {
  const { track } = useTracking()

  const handleCookieSettingsClick = () => {
    toggleOneTrustInfoDisplay()
    track(
      clickEvent({
        target: ClickableElement.CookieSettings,
        screen: Screen.MainFooter,
      }),
    )
  }

  return (
    <li className="main-footer__privacy-section-item">
      <button
        className="main-footer__privacy-section-link"
        type="button"
        onClick={handleCookieSettingsClick}
      >
        {cookieSettingsText}
      </button>
    </li>
  )
}

export default CookieSettingsButton
